module.exports = __webpack_public_path__ + "img/788-7c1db9.png";